export const USPS_CONSTANTS = {
	URLS: {
		TERMS_CONDITIONS: 'https://www.usps.com/terms-conditions',
	},
	FORM_FIELDS: {
		CRID_NUMBER: 'Crid',
		MID_NUMBER: 'ManifestMid',
		EPS_ACCOUNT_NUMBER: 'EpsAccountNumber',
	},
	VALIDATION_STATES: {
		INVALID: -1,
		INITIAL: 0,
		VALID: 1,
	},
};

export const INITIAL_FORM_DATA = {
	[USPS_CONSTANTS.FORM_FIELDS.CRID_NUMBER]: '',
	[USPS_CONSTANTS.FORM_FIELDS.MID_NUMBER]: '',
	[USPS_CONSTANTS.FORM_FIELDS.EPS_ACCOUNT_NUMBER]: '',
};

export const INITIAL_VALIDATIONS = {
	[USPS_CONSTANTS.FORM_FIELDS.CRID_NUMBER]:
		USPS_CONSTANTS.VALIDATION_STATES.INITIAL,
	[USPS_CONSTANTS.FORM_FIELDS.MID_NUMBER]:
		USPS_CONSTANTS.VALIDATION_STATES.INITIAL,
	[USPS_CONSTANTS.FORM_FIELDS.EPS_ACCOUNT_NUMBER]:
		USPS_CONSTANTS.VALIDATION_STATES.INITIAL,
};
